import styled from 'styled-components'
import Section, { SectionContainer, SectionHeader } from '../common/Section'

const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${({ theme }) => theme.spacing.xl};
  margin-top: ${({ theme }) => theme.spacing['3xl']};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    grid-template-columns: 1fr;
  }
`

const TestimonialCard = styled.div`
  background: ${({ theme }) => theme.colors.backgroundLight};
  border: 1px solid ${({ theme }) => theme.colors.backgroundLighter};
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: ${({ theme }) => theme.spacing.xl};
  transition: all ${({ theme }) => theme.transitions.base};

  &:hover {
    transform: translateY(-4px);
    box-shadow: ${({ theme }) => theme.shadows.lg};
    border-color: ${({ theme }) => theme.colors.primary};
  }
`

const Rating = styled.div`
  display: flex;
  gap: 4px;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  color: ${({ theme }) => theme.colors.accent};
  font-size: 20px;
`

const ReviewText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.lg};
  line-height: 1.7;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  font-style: italic;
`

const Reviewer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
`

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.gradientPrimary};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
`

const ReviewerInfo = styled.div`
  .name {
    font-weight: 600;
    color: ${({ theme }) => theme.colors.text};
    margin-bottom: 2px;
  }

  .title {
    font-size: ${({ theme }) => theme.fonts.sizes.sm};
    color: ${({ theme }) => theme.colors.textMuted};
  }
`

const testimonials = [
  {
    id: 1,
    rating: 5,
    text: "Nexus Realms is a masterpiece. The attention to detail, the story, and the gameplay are all on another level. This is what gaming should be.",
    author: 'Sarah Chen',
    title: 'Senior Editor, GameRevolution',
    avatar: 'SC',
  },
  {
    id: 2,
    rating: 5,
    text: "I've been gaming for 20 years, and Nexus Realms is one of the best experiences I've ever had. The world is alive, and the choices actually matter.",
    author: 'Marcus Johnson',
    title: 'Professional Streamer',
    avatar: 'MJ',
  },
  {
    id: 3,
    rating: 5,
    text: "The combat system is incredibly satisfying, and the visual design is breathtaking. Nexus Gaming Studios has created something truly special.",
    author: 'Elena Rodriguez',
    title: 'GameCritics Monthly',
    avatar: 'ER',
  },
  {
    id: 4,
    rating: 5,
    text: "From the stunning graphics to the gripping narrative, every aspect of Nexus Realms has been crafted with love and dedication. A must-play!",
    author: 'David Kim',
    title: 'Gaming Enthusiast',
    avatar: 'DK',
  },
]

const Testimonials = () => {
  return (
    <Section id="testimonials" className="gradient-bg">
      <SectionContainer>
        <SectionHeader>
          <h2>What Players Say</h2>
          <p>Don't just take our word for it—hear from the gaming community</p>
        </SectionHeader>

        <TestimonialsGrid>
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.id}>
              <Rating>
                {Array.from({ length: testimonial.rating }).map((_, i) => (
                  <span key={i}>★</span>
                ))}
              </Rating>
              <ReviewText>"{testimonial.text}"</ReviewText>
              <Reviewer>
                <Avatar>{testimonial.avatar}</Avatar>
                <ReviewerInfo>
                  <div className="name">{testimonial.author}</div>
                  <div className="title">{testimonial.title}</div>
                </ReviewerInfo>
              </Reviewer>
            </TestimonialCard>
          ))}
        </TestimonialsGrid>
      </SectionContainer>
    </Section>
  )
}

export default Testimonials
